import { render, staticRenderFns } from "./chooseTemplate.vue?vue&type=template&id=a725d582&"
import script from "./chooseTemplate.vue?vue&type=script&lang=js&"
export * from "./chooseTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports